import { cts_secure } from '../../../app/cts';
import apis from '../../../app/apis';
import provideRecaptchaToken from './recaptchaToken';
import store from '../../../configureStore';

const requestPin = async (formInput) => {
  const {
    method, email, sms, phone, areaCode: country_cd
  } = formInput;

  const { projectId: project_id } = store.store.getState().plugin;
  const { districtId: district_id } = store.store.getState().config;

  const token = await provideRecaptchaToken();
  let payload = { token, project_id, district_id };
  let urlPart;
  if (['sms', 'phone'].includes(method)) {
    const number = method === 'sms' ? sms : phone;
    payload = {
      ...payload, method, number, country_cd
    };
    urlPart = 'number';
  } else {
    payload = { ...payload, email };
    urlPart = 'email';
  }
  const { data: { success } } = await cts_secure('post', `${apis.reminderSignUp}/reminder/verify/${urlPart}`, payload);
  return success;
};

export default requestPin;
